import { render, staticRenderFns } from "./EditAccountPurposesComponent.vue?vue&type=template&id=b67c30f2&"
import script from "./EditAccountPurposesComponent.vue?vue&type=script&lang=js&"
export * from "./EditAccountPurposesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports